/* Opciones de Edición */

//*react- recursos
  import React, { useState, useEffect } from "react";
  import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 
  import ReactTooltip from "react-tooltip";
  import '../../../../css/mdi.css'; 
  import { Col, Row } from "react-bootstrap";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //'libreria' que cita el bote de basura
  import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"; //icono bote de basura 
  import { setRef } from "@mui/material";

//*archivos y componentes
  import VentanaLDAP from "./Configuracion.Panel.Editar.LDAP"; //ventana LDAP  

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
  
//*api's (servicios y store)
  import configurationsServicio from "../../../../api/recursos/configurations/configurations.servicio"; 
  import configurationsStore from "../../../../api/recursos/configurations/configurations.store"; 

  import usersServicio from "../../../../api/recursos/users/users.servicio"; 
  import usersStore from "../../../../api/recursos/users/users.store"; 

//*store's

//*interfaces
  interface propsEditarUN {
    tokenStore:any,
    idPanel:any,
    unId:any,
    unAcronimo:any,
    unProceso:any,
    unUsuNoAceptadas:any,
    unUsuAceptadas:any,
    unUsuConcluidas:any,
    unMisNoAceptadasOrigen:any,
    unMisAceptadasOrigen:any,
    unMisConcluidasOrigen:any,
    botonCierraSlidingPanel:any,
    recargaConfiguracionPanel:any,
    recargaPaginaSSC:any,
    recargaPaginaSSC_Not:any,
  }

//*componente
  export default function EditarUN(props: propsEditarUN){
    var _ = require('underscore');
  
    //*api store
        const { cambiaUsuariosNotificacionesStore, 
                guardaUpdateUserNotificationbyEmailStore, 
                canceloUsuariosNotificiacionesStore,
                generaObjErrorConfigurationsStore} =  
            configurationsStore((state:any) =>( { 
                cambiaUsuariosNotificacionesStore: state.cambiaUsuariosNotificacionesStore,
                guardaUpdateUserNotificationbyEmailStore: state.guardaUpdateUserNotificationbyEmailStore,
                canceloUsuariosNotificiacionesStore: state.canceloUsuariosNotificiacionesStore,
                generaObjErrorConfigurationsStore: state.generaObjErrorConfigurationsStore,
        }));

    //*store's
    //*datos
    
    //*constantes y variables
      let etiRP = etiquetasSSC.RP;
      let etiGlobal = etiquetasSSC.Global;
      let x0:any, x1:any, x2:any, x3:any, x4:any, x5:any, x6:any, x7:any , x8:any  = '';
      let copiaUpCatPermisos=[];
      let bodyApiGuardar:any = {id: 0, sync: true, rejectprop:[], okprop:[], okanalyse:[] }

    //*useState
      const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar
      const [swRecargaConfiguracionPanelEditarUN, setSwRecargaConfiguracionPanelEditarUN] = useState(false); //usado para remasterizar esta página
      const [cargandoSpin, setCargandoSpin] = useState(false);

      const [swBotonGuardarFront, setSwBotonGuardarFront] = useState(false);

      const [swUsuNoAceptadas, setSwUsuNoAceptadas] = useState(false);
      const [swUsuAceptadas, setSwUsuAceptadas] = useState(false);
      const [swUsuConcluidas, setSwUsuConcluidas] = useState(false);

      const [unUsuNoAceptadasFront, setUnUsuNoAceptadasFront] = useState(props.unUsuNoAceptadas);
      const [unUsuAceptadasFront, setUnUsuAceptadasFront] = useState(props.unUsuAceptadas);
      const [unUsuConcluidasFront, setUnUsuConcluidasFront] = useState(props.unUsuConcluidas);

      const [usuSeleccionado, setUsuSeleccionado] = useState('');
     
      //const [bodyApiGuardar, setBodyApiGuardar] = useState ( {id: 0, sync: true, rejectprop:[], okprop:[], okanalyse:[]} );

    
    //*useEffect
      useEffect(()=> { // cargo
        console.log('EditarUN - monto');
        //console.log('idPanel', props.idPanel);
        //console.log('unId', props.unId);

        if (props.unUsuNoAceptadas.length > 0) { setSwUsuNoAceptadas(true) }
        else { setSwUsuNoAceptadas(false) }

        if (props.unUsuAceptadas.length > 0) { setSwUsuAceptadas(true) }
        else { setSwUsuAceptadas(false) }

        if (props.unUsuConcluidas.length > 0) { setSwUsuConcluidas(true) }
        else { setSwUsuConcluidas(false) }

        bodyApiGuardar.id = props.unId;
        bodyApiGuardar.rejectprop = props.unUsuNoAceptadas;
        bodyApiGuardar.okprop = props.unUsuAceptadas;
        bodyApiGuardar.okanalyse = props.unUsuConcluidas;

        setUsuSeleccionado('');
      
        setSwRecarga(!swRecarga);
      },[]);
      
      useEffect(()=> { // uso este puente para recargar elementos del front
        console.log('EditarUN - rederizando............');
        setSwRecargaConfiguracionPanelEditarUN(!swRecargaConfiguracionPanelEditarUN)
        //console.log('-- bodyApiGuardar', bodyApiGuardar);
        //console.log('-- upCatPermisosOrigen', props.upCatPermisosOrigen);
        //console.log('-- upUsuariosEspecificosFront....', upUsuariosEspecificosFront)
        //console.log('upUsuariosEspecificosFront....', upUsuariosEspecificosFront);
      },[swRecarga]);

    //*funciones
      const recargaPaginaSSC = () => {props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC
      //const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana
      //const recargaConfiguracion = () => { props.recargaConfiguracion() }
      const recargaConfiguracionPanel = () => { props.recargaConfiguracionPanel() }


      const recargaConfiguracionPanelEditarUN = () => {
        //alert('recargaConfiguracionPanelEditarUN');
        //console.log('recargaConfiguracionPanelEditarUN....')
        setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
      }
    
      const botonCerrar = () => {  
        if (swBotonGuardarFront) { //si esta activo el botón guardar hay cambios...
                swal2.fire({
                    text: "",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    width: '50%',
                    html: "<div>" + 'Se detectaron cambios sin guardar. ¿Está seguro de salir de la ventana de Editar?'+ "</div>",
                }).then((result) => {
                    if (result.isConfirmed) {
                        canceloUsuariosNotificiacionesStore(props.unId);
                        recargaConfiguracionPanelEditarUN();
                        recargaConfiguracionPanel();
                        props.botonCierraSlidingPanel('');
                        setSwBotonGuardarFront(false);
                    }
                    else
                        return;
                })
        }
        else {  //cerramos SlipingPanel desde RD
          props.botonCierraSlidingPanel('');
        } 
        recargaConfiguracionPanelEditarUN();
      }

      const botonGuardar = () => {
          if (props.unId==0) { //selecciono el botón Editar de "Todos los programas a mi cargo"
              swal2.fire({
                title: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                width: '50%',
                html: "<div class='font-size-14'><p>" + "Con esta acción los usuarios que tenga asignados a los procesos serán sustituidos por los indicados en esta sección." + "<br /><br />" +  "Las configuraciones anteriormente especificadas para cada proceso se eliminarán y serán reemplazadas por las aquí definidas." + "<p><p class='text-center'> "+ "¿Desea continuar?" + "</p></div>",
              }).then((result) => {
                  if (result.isConfirmed) { guardaAPI() }
                  else { return }
              })
          }
          else { guardaAPI() }  
      }

      const guardaAPI = () => {
        //generamos body
          bodyApiGuardar.id = (props.unId==0) ? null : props.unId;
          bodyApiGuardar.rejectprop = unUsuNoAceptadasFront;
          bodyApiGuardar.okprop = unUsuAceptadasFront;
          bodyApiGuardar.okanalyse = unUsuConcluidasFront;
          if (swUsuNoAceptadas== false) { bodyApiGuardar.rejectprop= [] };
          if (swUsuAceptadas== false) { bodyApiGuardar.okprop= [] };
          if (swUsuConcluidas== false) { bodyApiGuardar.okanalyse= [] };
          console.log(':::::Antes de guardar-- bodyApiGuardar', bodyApiGuardar);
        // llamando al api: Configurations/UpdateProponentUser
          setCargandoSpin(true);
          configurationsServicio.cargaUpdateUserNotificationbyEmail(props.tokenStore, bodyApiGuardar)
            .then((response:any) => {
                if (response.status==200) {  //revisa si hay error
                      guardaUpdateUserNotificationbyEmailStore(response.data).then( function(datos:any) { 
                        //console.log('actualizamos API: ', datos );
                        setSwBotonGuardarFront(false);
                        swal2.fire({
                          title: 'La información para notificación de usuarios fue guardada', 
                          icon: 'success',
                          confirmButtonText: "Cerrar",
                          confirmButtonColor: '#3085d6',
                          width: "70%",
                        });
                        cambiaUsuariosNotificacionesStore(props.unId, bodyApiGuardar, 'botonGuardar');
                    });     
                }    
                props.recargaConfiguracionPanel();
                setCargandoSpin(false);
            })
            .catch((ex) => {
                console.log ("--catch - ex (cargaInsertbyUser): ", ex.response.status);
                generaObjErrorConfigurationsStore(ex.response, true, '', '', 'Configuración.Panel.EditarUN/UpdateUserNotificationbyEmailStore','C');
                recargaPaginaSSC();
                setCargandoSpin(false);
            })
          recargaConfiguracionPanel();  //actualizamos páginas de atrás
      }

      const activaSwBotonGuardar = () => {
         setSwBotonGuardarFront(true);
      }

      const clicInputCheck = (usuTipo:any) => {
        switch (usuTipo) {
          case 'NA': setSwUsuNoAceptadas(!swUsuNoAceptadas); break;
          case 'A':  setSwUsuAceptadas(!swUsuAceptadas); break;
          case 'C':  setSwUsuConcluidas(!swUsuConcluidas); break;
        }
        setSwBotonGuardarFront(true);
      }

      const cambiaListaUsuarios = (usuTipo:any, usuArreglo:any) => {
        //alert('cambiaListaUsuarios');
        console.log('EditarUN----cambiaListaUsuarios',usuTipo,usuArreglo );
        switch (usuTipo) {
          case 'NA': setUnUsuNoAceptadasFront(usuArreglo); break;
          case 'A':  setUnUsuAceptadasFront(usuArreglo);   break;
          case 'C':  setUnUsuConcluidasFront(usuArreglo);  break;
        }
        console.log('unUsuAceptadasFront......',unUsuAceptadasFront );
      }

   /*  */

    //**vista 
      return (
      <>
        {/* subencabezado: acronimo & nombre del proceso */}
           <div>
              <p className='color-secundario h4'>{props.unAcronimo}</p>
              <p className={props.unId==0 ? 'color-secundario h4' : 'h5'}>{props.unProceso}</p>
              <hr />
          </div>

        {/* contenido - id=1 - Adicionar usuarios para notificaciones vía correo electrónico */}
          <div id='SlidingPanel_contenido'>

              {/* Propuestas No aceptadas (No proceden)   */}
              <div>
                <p className='h5'> Propuestas No aceptadas (No proceden) </p> 
                <div className='margin-1r Font10'>  
                  <div className="divAnchoAvisos">
                    <input id='inputNA' type="checkbox" 
                            checked={swUsuNoAceptadas}
                            onClick={()=>clicInputCheck('NA')} />
                  </div>
                  <div style={{display:"inline-block"}}>Usuarios específicos seleccionados ( {props.unUsuNoAceptadas.length} )</div><br/>
                </div>
                {swUsuNoAceptadas &&  
                  (<> <VentanaLDAP 
                            tokenStore = {props.tokenStore} 
                            id = {props.unId} 
                            usuTipo = {'NA'}
                            listaUsuarios = {props.unUsuNoAceptadas} 
                            cambiaListaUsuarios = {cambiaListaUsuarios}
                            activaSwBotonGuardar = {activaSwBotonGuardar}
                            recargaConfiguracionPanel = {recargaConfiguracionPanel}
                            recargaConfiguracionPanelEditar = {recargaConfiguracionPanelEditarUN}
                            recargaPaginaSSC = {props.recargaPaginaSSC} /> </>) 
                }
              </div>  
              <hr />  

              {/* Propuestas Aceptadas (Previstas y No previstas) */}
              <div className='padding-top-1r'>
                  <p className='h5'>Propuestas Aceptadas (Previstas y No previstas)  </p> 
                  <div className='margin-1r Font10'>  
                    <div className="divAnchoAvisos">
                      <input id='inputA'type="checkbox" 
                              checked={swUsuAceptadas}
                              onClick={()=>clicInputCheck('A')}  />
                    </div>
                    <div style={{display:"inline-block"}}>Usuarios específicos seleccionados ( {props.unUsuAceptadas.length} )</div><br/>
                  </div>

                  {swUsuAceptadas  &&  
                    (<> <VentanaLDAP
                            tokenStore = {props.tokenStore} 
                            id = {props.unId} 
                            usuTipo = {'A'}
                            listaUsuarios = {props.unUsuAceptadas} 
                            cambiaListaUsuarios = {cambiaListaUsuarios}
                            activaSwBotonGuardar = {activaSwBotonGuardar}
                            recargaConfiguracionPanel = {recargaConfiguracionPanel}
                            recargaConfiguracionPanelEditar = {recargaConfiguracionPanelEditarUN}
                            recargaPaginaSSC = {props.recargaPaginaSSC} /> </>) 
                  }
              </div>
              <hr />  


              {/* Al concluir documentación de propuesta */}
              <div className='padding-top-1r'>
                  <p className='h5'> Al concluir documentación de propuesta </p> 
                  <div className='margin-1r Font10'>  
                    <div className="divAnchoAvisos">
                      <input id='inputc' type="checkbox" 
                              checked={swUsuConcluidas}
                              onClick={()=>clicInputCheck('C')}  />
                    </div>
                    <div style={{display:"inline-block"}}>Usuarios específicos seleccionados ( {props.unUsuConcluidas.length} )</div><br/>
                  </div>
                  {swUsuConcluidas  &&  
                    (<> <VentanaLDAP 
                            tokenStore = {props.tokenStore} 
                            id = {props.unId} 
                            usuTipo = {'C'}
                            listaUsuarios = {props.unUsuConcluidas}
                            cambiaListaUsuarios = {cambiaListaUsuarios} 
                            activaSwBotonGuardar = {activaSwBotonGuardar}
                            recargaConfiguracionPanel = {recargaConfiguracionPanel}
                            recargaConfiguracionPanelEditar = {recargaConfiguracionPanelEditarUN}
                            recargaPaginaSSC = {props.recargaPaginaSSC} /> </>) 
                  }
              </div>
              
          </div>
        
        {/* Botones */}
          <hr />
          <div id="SlidingPanel_pie">
            <div className='text-right padding-botton-1r'>
                { swBotonGuardarFront  
                    ? (<> <button onClick={botonGuardar} className="btn btn-activo">  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span></button>&nbsp;</> )
                    : (<> <button className="btn btn-inactivo" disabled>  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span> </button>&nbsp;</>)
                }
                <button onClick={botonCerrar}  className="btn btn-sinColor"> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[1].text, }} ></span> </button>&nbsp;
            </div>
          </div>

        {/* ventana de carga con spin que se abre mientras lee el api */}
          { cargandoSpin && <CargandoSpin />  }          
          
      </>
      );
  }
